import { SvgIcon, SvgIconProps } from "@mui/material";

export const StructuredPromptIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="var(--secondary-color)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			{...props}
		>
			<rect x="16" y="16" width="6" height="6" rx="1" fill="none"></rect>
			<rect x="2" y="16" width="6" height="6" rx="1" fill="none"></rect>
			<rect x="9" y="2" width="6" height="6" rx="1" fill="none"></rect>
			<path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" fill="none"></path>
			<path d="M12 12V8" fill="none"></path>
		</SvgIcon>
	);
};
